import { useEffect } from "react";

const SITE = "https://www.northwesttechalliance.com";
const DEFAULT_TITLE = "Northwest Tech Alliance | AI · Software · Innovation";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const usePageMeta = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | Northwest Tech Alliance` : DEFAULT_TITLE;
    document.title = fullTitle;
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('link[rel="canonical"]', "href", `${SITE}${path}`);
    setMeta('meta[property="og:url"]', "content", `${SITE}${path}`);
  }, [title, description, path]);
};
